var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',{attrs:{"placeholder":"editor loading..."}},[_c('div',{staticClass:"editor-wrap",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{ref:"monacoContainer",staticClass:"monaco-editor-container"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }